import React from "react";

interface ClientDashboardIconProps {
  fill?: string;
  width?: string;
  height?: string;
}

const ClientDashboardIcon: React.FC<ClientDashboardIconProps> = ({
  fill = "#ffffff",
  width = "1rem",
  height = "1rem",
}) => (
  <svg
    id={`Layer_2_${fill}`}
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 351.98 361.56"
    width={width}
    height={height}
    fill={fill}
  >
    <g id="Layer_1" data-name="Layer 1">
      <g id="01-Dashboard" data-name="01-Dashboard">
        <path d="M312.69,209.8c8.43,0,15.28,6.86,15.28,15.28v97.19c0,8.43-6.86,15.28-15.28,15.28h-81.53c-8.43,0-15.28-6.86-15.28-15.28v-97.19c0-8.43,6.86-15.28,15.28-15.28h81.53M312.69,185.8h-81.53c-21.7,0-39.28,17.59-39.28,39.28v97.19c0,21.7,17.59,39.28,39.28,39.28h81.53c21.7,0,39.28-17.59,39.28-39.28v-97.19c0-21.7-17.59-39.28-39.28-39.28h0Z" />
        <path d="M294.42,24c4.03,0,7.8,2.16,9.85,5.63l21.81,37.02c2.11,3.58,2.11,8.03,0,11.6l-21.81,37.02c-2.05,3.47-5.82,5.63-9.85,5.63h-44.88c-4.03,0-7.8-2.16-9.85-5.63l-21.81-37.02c-2.11-3.58-2.11-8.03,0-11.6l21.81-37.02c2.05-3.47,5.82-5.63,9.85-5.63h44.88M294.42,0h-44.88c-12.55,0-24.16,6.64-30.53,17.44l-21.81,37.02c-6.54,11.1-6.54,24.87,0,35.97l21.81,37.02c6.37,10.81,17.98,17.44,30.53,17.44h44.88c12.55,0,24.16-6.64,30.53-17.44l21.81-37.02c6.54-11.1,6.54-24.87,0-35.97l-21.81-37.02c-6.37-10.81-17.98-17.44-30.53-17.44h0Z" />
        <path d="M120.82,24c8.43,0,15.28,6.86,15.28,15.28v97.19c0,8.43-6.86,15.28-15.28,15.28H39.28c-8.43,0-15.28-6.86-15.28-15.28V39.28c0-8.43,6.86-15.28,15.28-15.28h81.53M120.82,0H39.28C17.59,0,0,17.59,0,39.28v97.19c0,21.7,17.59,39.28,39.28,39.28h81.53c21.7,0,39.28-17.59,39.28-39.28V39.28c0-21.7-17.59-39.28-39.28-39.28h0Z" />
        <path d="M102.54,240.66c4.03,0,7.8,2.16,9.85,5.63l21.81,37.02c2.11,3.58,2.11,8.03,0,11.6l-21.81,37.02c-2.05,3.47-5.82,5.63-9.85,5.63h-44.88c-4.03,0-7.8-2.16-9.85-5.63l-21.81-37.02c-2.11-3.58-2.11-8.03,0-11.6l21.81-37.02c2.05-3.47,5.82-5.63,9.85-5.63h44.88M102.54,216.66h-44.88c-12.55,0-24.16,6.64-30.53,17.44l-21.81,37.02c-6.54,11.1-6.54,24.87,0,35.97l21.81,37.02c6.37,10.81,17.98,17.44,30.53,17.44h44.88c12.55,0,24.16-6.64,30.53-17.44l21.81-37.02c6.54-11.1,6.54-24.87,0-35.97l-21.81-37.02c-6.37-10.81-17.98-17.44-30.53-17.44h0Z" />
      </g>
    </g>
  </svg>
);

export default ClientDashboardIcon;
